import { AdapterManager } from '../adapter/manager/AdapterManager.js';
import { AdapterType } from '../adapter/manager/types.js';
import { BrowserMediaUploader } from '../adapter/browser/BrowserMediaUploader.js';
import { MultimediaPluginCore } from './MultimediaPlugin.js';
export { MultimediaPluginCore } from './MultimediaPlugin.js';
export { FileExtKey, FileExtTypeValue, FileType, ImageTplvFormat, ImageTplvType, MultimediaPluginConsts } from './interfaces.js';

class MultimediaPlugin extends MultimediaPluginCore {
    initAdapter() {
        AdapterManager.setAdapter(AdapterType.MediaUploader, BrowserMediaUploader);
    }
}

export { MultimediaPlugin };
//# sourceMappingURL=index-browser.js.map
